import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ItemInfo } from "../../../../../projects/t4core/src/public-api";
import { PageBase, UIService } from 't4core';

@Component({
  styleUrls: ['./ServiceGuyItemsDashboard.component.css'],
  selector: 'ServiceGuyItems',
  templateUrl: './ServiceGuyItemsDashboard.component.html',
})

export class ServiceGuyItemsDashboardComponent extends PageBase implements OnInit {

  public listOfServiceGuyItems: ItemInfo[];

  public serviceGuyType: any;

  public item: ItemInfo;

  constructor(el: ElementRef,
    private route: ActivatedRoute,
    private ui: UIService) {
    super(el, "ServiceGuyItems");
  }

  public async createItem() {
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyItemDialog', { data: { item: null } });
    this.listOfServiceGuyItems = await this.Api.get<ItemInfo[]>("Service/GetItems");
  }

  async ngOnInit() {
    this.getItems();
  }

  public async getItems() {
    var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrLoadingServiceGuyItems", "Loading serviceGuyItems", null);
    this.listOfServiceGuyItems = await this.Api.get<ItemInfo[]>("Service/GetItems");
    this.UI.loaderCompleted(token);
  }

  public async update(row) {
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyItemDialog', { data: row });    
  }

  public async deleteItem(row) {

    var question = await this.UI.confirm('T4.Service.ServiceGuys.headConfirmDelete', 'Are you sure?', 'T4.Service.ServiceGuyItems.msgConfirmDelete', 'Are you sure you want to delete item? This operation cannot be undone!');
    if (question) {

      var item = new ItemInfo();
      item.ItemId = row.ItemId;
      item.Name = row.Name;

      var ret = await this.Api.delete<boolean>("Service/DeleteItem", { itemId: item.ItemId });
      this.listOfServiceGuyItems = await this.Api.get<ItemInfo[]>("Service/GetItems");
    }
  }
}
